import styled, { css, keyframes } from 'styled-components'
import { TooltipProps } from './Tooltip.types'
import { OpenStatus } from '../../hooks/usePopupAnimation/usePopupAmimation.types'

export const tooltipEnterOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

export const tooltipExitOpacity = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`

export const Content = styled.div`
  position: relative;
  padding: 20px;
  border-radius: 4px;
  background: ${props => props.theme.palette.white};
  box-shadow: ${props => props.theme.shadows.base};
  max-width: 350px;
  box-sizing: border-box;
  opacity: 0;

  font-size: 13px;
  line-height: 20px;
  color: ${props => props.theme.palette.primaryText};
`

export const TriggerButton = styled.button<{
  isOpened: boolean
}>`
  display: inline-block;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0;
  width: 16px;
  height: 16px;
  border: none;
  background-color: transparent;
  fill: ${({ theme }) => theme.palette.black[50]};

  ${({ theme }) => css`
    transition: fill ${theme.transitions.duration[200]} ${theme.transitions.easing.linear},
      background-color ${theme.transitions.duration[200]} ${theme.transitions.easing.linear};
  `}

  &:focus {
    outline: none;
  }

  &::-moz-focus-inner {
    border: 0;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.defaultHoverBG};
  }

  ${({ isOpened, theme }) =>
    isOpened &&
    css`
      fill: ${theme.palette.tooltipIconColorHover};
    `}
`

export const StyledTooltip = styled.div<{
  zIndex: TooltipProps['zIndex']
  openStatus: OpenStatus
}>`
  position: absolute;
  z-index: ${props => props.zIndex};

  ${({ openStatus, theme }) => {
    switch (openStatus) {
      case 'entering':
      case 'mounted':
        return css`
          & ${Content} {
            animation: ${tooltipEnterOpacity} ${theme.transitions.duration[200]}
                ${theme.transitions.easing.linear} forwards,
              top ${theme.transitions.duration[200]} ${theme.transitions.easing.easeOut} forwards;
          }
        `
      case 'exiting':
        return css`
          & ${Content} {
            animation: ${tooltipExitOpacity} ${theme.transitions.duration[200]}
                ${theme.transitions.easing.linear} forwards,
              top ${theme.transitions.duration[200]} ${theme.transitions.easing.easeIn} forwards;
          }
        `
      case 'unmounted':
        return css`
          pointer-events: none;
          opacity: 0;
        `
      default:
        return css``
    }
  }}
`

export const Arrow = styled.div`
  position: absolute;
  width: 1em;
  height: 7px;

  &[data-placement*='bottom'] {
    top: 0;
    left: 0;
    margin-top: -7px;
    &::before {
      border-width: 0 7px 7px 7px;
      border-color: transparent transparent white transparent;
    }
  }
  &[data-placement*='top'] {
    bottom: 0;
    left: 0;
    margin-bottom: -7px;
    &::before {
      border-width: 7px 7px 0 7px;
      border-color: white transparent transparent transparent;
    }
  }
  &[data-placement*='right'] {
    left: 0;
    margin-left: -7px;
    &::before {
      border-width: 7px 7px 7px 0;
      border-color: transparent white transparent transparent;
    }
  }
  &[data-placement*='left'] {
    right: 0;
    margin-right: -7px;
    &::before {
      border-width: 7px 0 7px 7px;
      border-color: transparent transparent transparent white;
    }
  }
  &::before {
    content: '';
    margin: auto;
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
  }
`
